import React, { useState } from "react";
import { FaWhatsapp, FaTimes, FaPaperPlane } from "react-icons/fa";
import "./WhatsAppBot.css";

export default function WhatsAppBot() {

const questions = [
"שלום 👋 אני הנציג הדיגיטלי של איטומים בגבהים !\nאשאל אותך כמה שאלות קצרות כדי שנוכל לחזור אליך עם פתרון מתאים\n ",
    "איזו בעיה קיימת ?",
    "באיזה עיר נמצא הנכס ?",
    "מה השם שלך ?",
    "מה מספר הטלפון שלך ?"
];

const options = [
    [
          "צריך בדיקת איטום",
        "יש לי נזילה ",
        "האם מדובר במקרה דחוף?",
       "אני צריך הצעת מחיר",
        "אחר"
    ],
    [
         "נזילה מהגג",
    "רטיבות בתקרה",
    "רטיבות בקירות",
    "איטום מרפסת",
    "חדירת מים מחלונות",
    "איטום מרתף",
    "סדקים בקירות חיצוניים",
    "איטום לאחר שיפוץ",
    "בדיקת איטום כללית",
    "אחר"
    ]
];


    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([
        { type: "bot", text: questions[0] }
    ]);

    const [step, setStep] = useState(0);
    const [input, setInput] = useState("");
    const [answers, setAnswers] = useState([]);
    const [selectedOption, setSelectedOption] = useState(false);
    const [finished, setFinished] = useState(false);

function selectOption(option) {

    setAnswers(prev => [...prev, option]);

    setMessages(prev => [
        ...prev,
        {
            type: "user",
            text: option
        }
    ]);

    setSelectedOption(true);


    if (step < questions.length - 1) {

        setTimeout(() => {

            const nextStep = step + 1;

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: questions[nextStep]
                }
            ]);

            setStep(nextStep);
            setSelectedOption(false);

        }, 500);

    }
}
function sendMessage() {

    if (!input.trim()) return;

    if (options[step]) return;

// עיר
if (step === 2) {

    const cityRegex = /^[א-תa-zA-Z\s]{2,}$/;

    if (!cityRegex.test(input.trim())) {

        setMessages(prev => [
            ...prev,
            {
                type:"bot",
                text:"❌ נא להזין עיר תקינה"
            }
        ]);

        return;
    }
}





    // שם
  if (step === 3) {

        const nameRegex = /^[א-תa-zA-Z\s]{2,}$/;

        if (!nameRegex.test(input.trim())) {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "❌ נא להזין שם תקין"
                }
            ]);

            return;
        }
    }

    // טלפון
  if (step === 4) {

        const cleanPhone = input.replace(/\D/g, "");

        if (!/^05\d{8}$/.test(cleanPhone)) {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "❌ נא להזין מספר טלפון תקין\nלדוגמה: 0501234567"
                }
            ]);

            return;
        }

        setAnswers(prev => [...prev, cleanPhone]);

        setMessages(prev => [
            ...prev,
            {
                type: "user",
                text: cleanPhone
            }
        ]);

        setInput("");

        setStep(questions.length);

        setTimeout(() => {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "🎉 מעולה!\nלחץ על הכפתור לשליחה לוואטסאפ"
                }
            ]);

            setFinished(true);

        }, 500);

        return;
    }

    setAnswers(prev => [...prev, input]);

    setMessages(prev => [
        ...prev,
        {
            type: "user",
            text: input
        }
    ]);

    setInput("");

    setTimeout(() => {

        const nextStep = step + 1;

        setMessages(prev => [
            ...prev,
            {
                type: "bot",
                text: questions[nextStep]
            }
        ]);

        setStep(nextStep);

    }, 500);
}
function sendWhatsapp() {

const text = `
🏠 פנייה חדשה מהאתר - איטומים בגבהים

סיבת הפנייה:
${answers[0] || ""}

סוג העבודה:
${answers[1] || ""}

עיר:
${answers[2] || ""}

שם:
${answers[3] || ""}

טלפון:
${answers[4] || ""}
`;

window.open(
    `https://api.whatsapp.com/send?phone=972526422426&text=${encodeURIComponent(text)}`,
    "_blank"
);

setFinished(false);

setMessages(prev => [
    ...prev,
    {
        type:"bot",
        text:"✅ תודה רבה !\nקיבלנו את הפרטים.\nאחד המומחים שלנו יחזור אליך בהקדם."
    }
]);

setTimeout(() => {
    setStep(0);
    setAnswers([]);
    setInput("");

    setMessages([
        {
            type: "bot",
            text: questions[0]
        }
    ]);
}, 30000); // אחרי 30 שניות
}
    return (
        <>
            <button className="wa-button" onClick={() => setOpen(true)}>
                <FaWhatsapp />
            </button>

            {open && (
                <div className="chat">

                    <div className="header2">
                        <div className="logoArea">
                    <img src="/logo512.png" alt="איטומים בגבהים" />
                            <span>איטומים בגבהים</span>
                        </div>

                        <button onClick={() => setOpen(false)}>
                            <FaTimes />
                        </button>
                    </div>

                    <div className="messages">

                        {messages.map((msg, i) => (
                            <div
                                key={i}
                                className={msg.type === "bot" ? "bot" : "user"}
                            >
                                {msg.text}
                            </div>
                        ))}

                        {options[step] && !selectedOption && (
                            <div className="options">
                                {options[step].map((item, i) => (
                                    <button
                                        key={i}
                                        onClick={() => selectOption(item)}
                                    >
                                        ◯ {item}
                                    </button>
                                ))}
                            </div>
                        )}

                    </div>

                    {/* INPUT רק בשאלות פתוחות */}
                    {!options[step] && (
                        <div className="inputBox">

                            <input
                                value={input}
                                onChange={e => setInput(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === "Enter") sendMessage();
                                }}
                                placeholder="כתוב הודעה..."
                            />

                            <button onClick={sendMessage}>
                                <FaPaperPlane />
                            </button>

                        </div>
                    )}

                    {/* כפתור וואטסאפ רק בסוף */}
                    {finished && (
                        <button className="sendWA" onClick={sendWhatsapp}>
                            שליחה לוואטסאפ 🟢
                        </button>
                    )}

                </div>
            )}
        </>
    );
}